import { useState } from "react";
import { Menu, X } from "lucide-react";

export const NAV = [
  ["#about", "About"],
  ["#what-we-do", "What We Do"],
  ["#track-record", "Track Record"],
  ["#team", "Team"],
  ["#who-we-work-with", "Who We Work With"],
  ["#contact", "Contact"],
];

const id = (href) => href.slice(1);

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-[#1B3A6B]/10 bg-white/95 backdrop-blur-md" data-testid="site-header">
      <nav aria-label="Primary" className="als-container flex min-h-[64px] items-center justify-between gap-x-4 py-2">
        <a href="#top" className="flex items-center" aria-label="Arka Likas Solutions — back to top" data-testid="header-logo-link">
          <img src="/arka-likas-logo.png" alt="Arka Likas Solutions logo" className="h-9 w-auto" width="45" height="36" />
        </a>
        <div className="hidden items-center gap-x-7 md:flex lg:gap-x-9">
          {NAV.map(([href, label]) => (
            <a key={href} href={href} className="nav-link" data-testid={`nav-${id(href)}`}>{label}</a>
          ))}
        </div>
        <button type="button" className="text-[#1B3A6B] md:hidden" aria-expanded={open} aria-label={open ? "Close menu" : "Open menu"} onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X size={22} strokeWidth={1.75} /> : <Menu size={22} strokeWidth={1.75} />}
        </button>
      </nav>
      {open && (
        <div className="als-container md:hidden" data-testid="mobile-menu">
          <ul className="border-t border-[#1B3A6B]/10 py-2">
            {NAV.map(([href, label]) => (
              <li key={href}>
                <a href={href} className="block py-3 text-[15px] text-[#111111]" onClick={() => setOpen(false)} data-testid={`mobile-nav-${id(href)}`}>{label}</a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
};
